import { constante } from "../../actions/notification-action";
import { INotification } from "../../types/notification-interface";
import { IAction } from "../../types/type-action";

const initialState: INotification = {
  totalNumberUnread: 0,
  data: [],
};

export default function notificationReducer(
  state = initialState,
  action: IAction
) {
  switch (action.type) {
    case constante.MARK_AS_READ:
      return {
        ...state,
        totalNumberUnread: state.totalNumberUnread - 1,
      };
    // case constante.MARK_ALL_AS_READ:
    //   return {
    //     ...state,
    //     totalNumberUnread: 0,
    //   };
    case constante.ADD_NOTIFICATION:
      return {
        ...state,
        totalNumberUnread: action.payload.numberUnread,
        data: action.payload.notifications,
      };
    default:
      return state;
  }
}
